import styled from 'styled-components';

interface IconSize { iconSize: string; }

export const Root = styled.div<IconSize>`
  display: block;
  width: 100%;
  height: 100%;
  color: inherit;
  text-align: center;
  font-size: ${p => p.iconSize};
  line-height: ${p => p.iconSize};
`;
